<header class="header-container" [class.scrolled]="isScrolled">
  
  <div class="menu-overlay" [class.active]="isMenuOpen" (click)="closeMenu()"></div>

  <nav class="navbar-pill">
    <div class="logo-container" routerLink="/" (click)="closeMenu()">
      <img src="assets/images/logo-argentus.png" class="logo-img" alt="Logo">
    </div>  

    <ul class="nav-links" [class.mobile-open]="isMenuOpen">
      @for (item of navItems; track $index) {
        <li>
          <a routerLink="{{ item.link }}" 
             routerLinkActive="active" 
             [routerLinkActiveOptions]="{exact: true}" 
             (click)="closeMenu()">
            {{ item.label }}
          </a>
        </li>
      }

      <button
        type="button"
        class="cart-button"
        aria-label="Abrir carrito"
        (click)="cartService.toggleCart()"
      >
      <span class="cart-button__icon" aria-hidden="true">
        <svg
          viewBox="0 0 24 24"
          width="22"
          height="22"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
        <circle cx="9" cy="20" r="1"></circle>
        <circle cx="18" cy="20" r="1"></circle>
        <path d="M3 4h2l2.4 11.2a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.6L21 8H6"></path>
        </svg>
      </span>

      <span class="cart-button__label">Carrito</span>

      @if (cartService.itemCount() > 0) {
        <span
          class="cart-button__badge"
          aria-label="{{ cartService.itemCount() }} productos en el carrito"
        >
          {{ cartService.itemCount() > 99 ? '99+' : cartService.itemCount() }}
        </span>
      }
    </button>

    </ul>

    <button class="hamburger-btn" (click)="toggleMenu()" [class.active]="isMenuOpen">
      <span class="bar"></span>
      <span class="bar"></span>
      <span class="bar"></span>
    </button>
  </nav>

</header>
